import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiTooltip = (baseTheme: Theme): Partial<Components> => ({
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: baseTheme.palette.text.primary,
        color: baseTheme.palette.background.default,
        borderRadius: 12,
        maxWidth: 410,
      },
      arrow: {
        color: baseTheme.palette.text.primary,
      },
    },
  },
});
